<template>
    <div class="form">
        <h4 class="step-title">
            How many days do you commute?
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <button-list v-bind:items="daysDrivenPerWeekRanges" v-bind:onclick="complete"/>
        </div>
    </div>
</template>

<script>
    import ButtonList from "./shared/ButtonList.vue"

    export default {
        name: "VehicleDaysDrivenPerWeek",
        components: {
            ButtonList
        },
        data: function() {
            return {
                daysDrivenPerWeekRanges: [
                    { text: "0-2 Days", value: 2 },
                    { text: "3-5 Days", value: 5 },
                    { text: "6-7 Days", value: 7 }
                ]
            }
        },
        props: {
            lead: Object
        },
        computed: {
            vehicle: function() {
                return this.lead.vehicles[this.lead.vehicles.length-1];
            }
        },
        methods: {
            complete: function(vehicleDaysDrivenPerWeek) {
                this.vehicle.daysDrivenPerWeek = vehicleDaysDrivenPerWeek;
                this.$emit("complete", this.$options.name, this.vehicle.daysDrivenPerWeek);
            }
        }
    }
</script>
